/**
 * @generated SignedSource<<50f8f58a550cdbb49cb483bfb7ff1359>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useNoSurveysFragmentQuery_noSurveysRef$data = {
  readonly endlessProfilerUrl: string | null;
  readonly notificationSubscriptions: {
    readonly " $fragmentSpreads": FragmentRefs<"PushNotificationsCardFragment_notificationSubscriptions">;
  };
  readonly profilerUrl: string | null;
  readonly userData: {
    readonly firstName: string | null;
  } | null;
  readonly " $fragmentType": "useNoSurveysFragmentQuery_noSurveysRef";
};
export type useNoSurveysFragmentQuery_noSurveysRef$key = {
  readonly " $data"?: useNoSurveysFragmentQuery_noSurveysRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNoSurveysFragmentQuery_noSurveysRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useNoSurveysFragmentQuery_noSurveysRef",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endlessProfilerUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profilerUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserData",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NotificationSubscriptions",
      "kind": "LinkedField",
      "name": "notificationSubscriptions",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PushNotificationsCardFragment_notificationSubscriptions"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ef369eb59f1ae71fa9181368b6b00dd0";

export default node;
